<div class="content md3-surface">
  <div class="layout-list-quickfilter md3-card-on-surface">
    <!-- Search Header -->
    <exg-search-bar (Search)="caseTable.search($event)" [placeholder]="getRessource('SearchHolder')"
                    class="span-layout">
      <ng-template #rightTemplate>
        <i (click)="caseTable.loadData()" class="search-action fal fa-sync"></i>
        <app-exg-dropdown>
          <ng-template #hostTemplate>
            <i class="search-action fa-filter"
               [class.fas]="caseTable.uiFilterAktiv(1).length > 0"
               [class.fal]="caseTable.uiFilterAktiv(1).length === 0"></i>
          </ng-template>
          <ng-template #contentTemplate let-popup>
            <app-exg-filter #VCcaseTableFilterControl
                            (onActivateFilter)="caseTable.pageChanged(1);popup.close()"
                            [MetaInfo]="caseTable.MetaInfo"
                            [visibility]="popup.visibility !== 'hidden'"
                            [showFilter]="true" [uiFilter]="caseTable.uiFilter"
                            [uiSort]="caseTable.uiSort"></app-exg-filter>
          </ng-template>
        </app-exg-dropdown>
        <app-exg-dropdown>
          <ng-template #hostTemplate>
            <i class="search-action fa-sort-alt"
               [class.fas]="caseTable.uiSortAktiv().length > 0"
               [class.fal]="caseTable.uiSortAktiv().length === 0"></i>
          </ng-template>
          <ng-template #contentTemplate let-popup>
            <app-exg-filter #VCcaseTableSortControl
                            (onActivateFilter)="caseTable.pageChanged(1);popup.close()"
                            [visibility]="popup.visibility !== 'hidden'"
                            [MetaInfo]="caseTable.MetaInfo"
                            [showSort]="true" [uiFilter]="caseTable.uiFilter"
                            [uiSort]="caseTable.uiSort"></app-exg-filter>
          </ng-template>
        </app-exg-dropdown>
        <app-exg-dropdown>
          <ng-template #hostTemplate>
            <i class="search-action fa-binoculars"
               [class.fas]="caseTable.uiFilterAktiv(2).length > 0"
               [class.fal]="caseTable.uiFilterAktiv(2).length === 0"></i>
          </ng-template>
          <ng-template #contentTemplate let-popup>
            <app-exg-filter (onActivateFilter)="caseTable.pageChanged(1);popup.close()"
                            [MetaInfo]="caseTable.MetaInfo" #VCcaseTableSearchControl
                            [visibility]="popup.visibility !== 'hidden'"
                            [showSearch]="true" [uiFilter]="caseTable.uiFilter"
                            [uiSort]="caseTable.uiSort"></app-exg-filter>
          </ng-template>
        </app-exg-dropdown>
        <i class="search-action fal fa-gears"
           [class.disabled]="!caseTable.newV2Table"
           (click)="openTableSettings($event)">
        </i>
        <exg-table-settings #tableDefinitionSettings
                            [tableDef]="caseTable.tableDefinition"
                            [metaInfo]="caseTable.MetaInfo"
                            localStorageID="caseTable">
        </exg-table-settings>
        <i class="search-action fa-table"
           (click)="caseTable.newV2Table = !caseTable.newV2Table; chDecRefWakeUp();"
           [class.fas]="caseTable.newV2Table"
           [class.fal]="!caseTable.newV2Table">
        </i>
        <i [class.disabled]="!excSecurity.isFeatured('CASECREATE')"
           class="search-action fal fa-plus"
           (click)="openCaseCreatorTab()">
        </i>
      </ng-template>
    </exg-search-bar>
    <!-- DataTable -->
    <div class="content">
      <ng-container *ngIf="!caseTable.newV2Table">
        <exg-data-table #VCcaseTable
                        (ItemSelect)="caseTable.selectedRow"
                        [selectSource]="caseTable.selectedRow"
                        (RowChange)="caseTable.selectionChanged($event)"
                        (RowDblClick)="openWorkspaceV2($event)"
                        [allowSingleSelection]="true"
                        [displayState]="caseTable.state"
                        [rowSource]="caseTable.data"
                        containerClass="grid cols-21"
                        [selectKey]="caseTable.selectKey">
          <ng-template #headerTemplate>
            <div class="span-2">
              <p class="typo-small">
                <strong>{{enumSvc.getFieldCaption('Auftrag', 'auNr')}}</strong>
              </p>
              <p class="typo-small">
                <strong>{{enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenNr')}}</strong>
              </p>
            </div>
            <div class="span-3">
              <p><strong>{{enumSvc.getFieldCaption('Auftrag', 'aueVersicherungsnehmer')}}</strong></p>
              <p>
                <strong>{{enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenOrt')}}</strong>
              </p>
            </div>
            <div class="span-2">
              <p>
                <strong>{{enumSvc.getFieldCaption('Auftrag', 'auAuftraggeber')}}</strong>
              </p>
              <p><strong>{{enumSvc.getFieldCaption('Auftrag', 'au_enmIdent_AuftragStatus')}}</strong></p>
            </div>
            <div class="span-2">
              <p><strong>{{enumSvc.getFieldCaption('Auftrag', 'au_enmIdent_AuftragTyp')}}</strong></p>
              <p><strong>
                {{enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_SchadenArt')}}
                ({{enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_Versicherungsart')}})</strong></p>
            </div>
            <div class="span-2">
              <p><strong>{{enumSvc.getFieldCaption('AuftragE_EIS', 'aueLetzterSachverstaendiger')}}</strong></p>
              <p><strong>{{enumSvc.getFieldCaption('AuftragE_EIS', 'aueLetzterQSPruefer')}}</strong></p>
            </div>
            <div class="span-2">
              <p><strong>{{enumSvc.getFieldCaption('AuftragE_EIS', 'aueOrtstermin')}}
                ({{enumSvc.getFieldCaption('AuftragE_EIS', 'aueOrtsterminPlan')}})</strong></p>
              <p><strong>{{enumSvc.getFieldCaption('AuftragE_EIS', 'aueOrtstermin2')}}</strong></p>
            </div>
            <div class="span-2">
              <p><strong>{{enumSvc.getFieldCaption('AuftragE_EIS', 'aueKontaktaufnahmeVersuche')}}</strong></p>
            </div>
            <div class="span-2">
              <p><strong>{{enumSvc.getFieldCaption('All', '%CKU')}}</strong></p>
              <p><strong>{{enumSvc.getFieldCaption('All', '%CKD')}}</strong></p>
            </div>
            <div class="span-2">
              <p>
                <strong>
                  {{enumSvc.getFieldCaption('All', '%LCU')}}
                </strong>
              </p>
              <p>
                <strong>
                  {{enumSvc.getFieldCaption('All', '%LCD')}}
                </strong>
              </p>
            </div>
            <div class="span-2">
              <p>
                <strong>
                  {{enumSvc.getFieldCaption('AuftragE_EIS', 'aueAbrechnungshinweis_enmIdent')}}
                </strong>
              </p>
              <p>
                <strong>
                  {{enumSvc.getFieldCaption('AuftragE_EIS', 'aueAbschlussdatum')}}
                </strong>
              </p>
            </div>
          </ng-template>
          <ng-template #rowTemplate let-row>
            <div class="span-2">
              <p>{{row.auNr}}</p>
              <p>{{row.aueSchadenNr}}</p>
            </div>
            <div class="span-3">
              <p>{{row.aueVersicherungsnehmer}}</p>
              <p>{{row.aueSchadenOrt || '-'}}</p>
            </div>
            <div class="span-2">
              <p>{{row.auAuftraggeberShort}}</p>
              <p>{{enumSvc.getEnumerationText('AuftragStatus', row.au_enmIdent_AuftragStatus)}}</p>
            </div>
            <div class="span-2">
              <p>
                {{enumSvc.getEnumerationText('AuftragTyp', row.au_enmIdent_AuftragTyp)}}
              </p>
              <p>
                {{enumSvc.getEnumerationText('Schadenart', row.aue_enmIdent_SchadenArt)}}
                ({{enumSvc.getEnumerationText('Versicherungsart', row.aue_enmIdent_Versicherungsart)}})
              </p>
            </div>
            <div class="span-2">
              <p>{{row.aueLetzterSachverstaendiger || '-'}}</p>
              <p>{{row.aueLetzterQSPruefer || '-'}}</p>
            </div>
            <div class="span-2">
              <p>
                {{row.aueOrtstermin | excDate: getGlobal('DateFormat')}}
                {{!row.aueOrtsterminPlan && !row.aueOrtstermin ? '-' : '' }}
                ({{row.aueOrtsterminPlan | excDate: getGlobal('DateFormat')}}
                {{!row.aueOrtsterminPlan ? '- ' : '' }})
              </p>
              <p *ngIf="row.aueOrtstermin2">
                {{row.aueOrtstermin2 | excDate: getGlobal('DateFormat')}}
                {{!row.aueOrtsterminPlan ? '-' : '' }}
              </p>
            </div>
            <div class="span-2">
              <p>
                {{row.auMaxCKU || '-'}}
              </p>
              <p>
                {{row.auMaxCKD | excDate: getGlobal('DateTimeFormatShort')}}
              </p>
            </div>
            <div class="span-2">
              <p>
                {{row.contactAttempt | excDate: getGlobal('DateTimeFormatShort')}}
              </p>
            </div>
            <div class="span-2">
              <p>
                {{row.auLCU || '-'}}
              </p>
              <p>
                {{row.auLCD | excDate: getGlobal('DateTimeFormatShort')}}
              </p>
            </div>
            <div class="span-2">
              <p *ngIf="row.aueAbrechnungshinweis_enmIdent">
                {{enumSvc.getEnumerationText('Abrechnungshinweis', row.aueAbrechnungshinweis_enmIdent)}}
              </p>
              <p *ngIf="!row.aueAbrechnungshinweis_enmIdent">
                -
              </p>
              <p>
                {{row.aueAbschlussdatum | excDate: getGlobal('DateFormat')}}
              </p>
            </div>
          </ng-template>
        </exg-data-table>
      </ng-container>
      <ng-container *ngIf="caseTable.newV2Table">
        <exg-table #VCcaseTableV2
                   (RowDblClick)="openWorkspace($event)"
                   (RowChange)="caseTable.selectionChanged($event)"
                   (FilterActivation)="caseTable.loadData()"
                   [selectKey]="caseTable.selectKey"
                   [rowSource]="caseTable.data"
                   [tableDef]="caseTable.tableDefinition"
                   [distinctTableName]="'Auftraege'"
                   [metaInfo]="caseTable.MetaInfo"
                   [displayState]="caseTable.state"
                   class="content"
                   [allowMultiSelection]="false"
                   [allowSingleSelection]="true"
                   (loadDistinct)="caseTable.getDistinctData($event)"
                   [distinctData]="caseTable.distinctData">
        </exg-table>
      </ng-container>
      <!-- Drawer -->
      <div class="drawer-container right app-table-drawer">
        <div [ngClass]="{'visible': rightDrawerVisible }"
             class="drawer-content md3-card-on-surface app-space-right_0">
          <div class="content width-500 ">
            <app-exg-tab-v2 #VCrightTabControl [header]="rightTabs"
                     [hidden] ="(appSvc.isTableLoading(caseTable) || appSvc.isTableLoading(CaseSummary.caseDetails)) || pendingLoading"
                     *ngIf ="!(appSvc.isTableLoading(CaseSummary.caseDetails))"
                     (tabchange)="rightTabs_tabChange($event)">
              <ng-template #pages>
                <div class="app-subarea app-space-right content">
                  <app-drawer-case-details
                    *ngIf="CaseSummary && !CaseSummary.isLoading && this.excSecurity.isFeatured('CASEREAD')"
                    [data]="CaseSummary?.caseDetails?.data"
                    [oeList]="CaseSummary?.oeList?.data"
                    [Schadenort]="CaseSummary?.Schadenort?.data">
                  </app-drawer-case-details>
                  <ng-container
                    *ngIf="!this.excSecurity.isFeatured('CASEREAD')"
                  >
                    <div style="text-align: center;
                                margin-top: 5rem;
                                color: var(--c-neutral-800);">
                      <i class="fas fa-exclamation-triangle fa-2xl" style="margin-bottom: 2rem"></i>
                      <div style="margin: 0 1rem">Sie sind nicht berechtigt Auftragdetails abzurufen!</div>
                    </div>
                  </ng-container>
                </div>
                <div class="content">
                  <div class="layout-1-auto">
                    <div class="content">
                      <exg-data-list #VCtaskList
                                     selectKey="vorgID"
                                     [displayState]="CaseSummary?.taskList?.data && CaseSummary?.taskList?.data.length > 0 ? 0 : 2"
                                     [rowSource]="CaseSummary?.taskList?.data || []"
                                     [selectSourceRows]="config.taskList.selectedObjects"
                                     (RowChange)="config.taskList.rowChange($event)"
                                     (ItemSelect)="config.taskList.itemSelect($event)">
                        <ng-template #rowTemplate let-task>
                          <div class="list-row-auto-1 app-cursor-pointer"
                               (dblclick)="onClickOpenTaskCheckview(task)"
                               [class.active]="config.taskList.selectedObjects[0] === task">
                            <div></div>
                            <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
                              <div class="list-metadata" style="margin-left:0">
                                <div>
                                  {{enumSvc.getEnumerationText('VorgangStatus', task.vorg_enmIdent_VorgangStatus)}} -
                                  {{enumSvc.getEnumerationText('VorgangTyp', task.vorg_enmIdent_VorgangTyp)}}
                                </div>
                                <div>Auftraggeber: {{task.auAuftraggeberShort}}
                                  Schadenart: {{enumSvc.getEnumerationText('Schadenart', task.aue_enmIdent_SchadenArt)}}</div>
                              </div>
                              <div class="list-metadata ">
                                <div
                                  class="typo-right">{{task.vorgLCD | excDate: 'Globals.DateTimeFormatShort'}}
                                </div>
                              </div>
                              <div style="height: 30px">
                          <span class="typo-center">
                            <span [tooltip]="'Nicht Geprüft'" flow="right">
                              <i class="fa-light fa-xmark c-red" style="font-size: 14px" *ngIf="!task.vorgCKD"></i>
                            </span>
                            <span [tooltip]="'Geprüft'" flow="right">
                              <i class="fa-light fa-check c-green" style="font-size: 14px" *ngIf="task.vorgCKD"></i>
                            </span>
                          </span>
                                <span class="app-space-left">
                            <strong>{{task.vorgNr}}</strong>
                          </span>
                              </div>
                              <div class="typo-right">
                                <i class="search-action fa-regular fa-chevron-right"
                                   *ngIf="config.taskList.selectedObjects[0] === task"
                                   (click)="onClickOpenTaskCheckview(task)">
                                </i>
                              </div>
                              <div class="span-2 typo-container-s-s-q app-space-left_none">
                                <ng-container *ngIf="task.vorgBeschreibung && task.vorgBeschreibung.length > 0">
                                  <span style="width: 148px">
                                    {{enumSvc.getFieldCaption('Vorgang', 'vorgBeschreibung')}}:
                                  </span>
                                        <span class="typo-left"
                                              *ngIf="config.taskList.selectedObjects[0] === task">
                                    {{task.vorgBeschreibung}}
                                  </span>
                                        <span class="typo-left"
                                              *ngIf="config.taskList.selectedObjects[0] !== task">
                                    {{task.vorgBeschreibung.slice(0, 48)}}
                                          {{task.vorgBeschreibung.length > 48 ? '...' : ''}}
                                  </span>
                                        <q></q>
                                      </ng-container>
                                      <ng-container *ngIf="task.vorgBearbeiter && task.vorgBearbeiter.length > 0">
                                   <span style="width: 148px">
                                   {{enumSvc.getFieldCaption('Vorgang', 'vorgBearbeiter')}}:
                                  </span>
                                        <span class="typo-left">
                                    {{task.vorgBearbeiter}}
                                  </span>
                                  <q></q>
                                </ng-container>

                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </exg-data-list>
                    </div>
                    <div>
                    </div>
                  </div>
                </div>
                <!--3 - Anhänge -->
                <div class="content">
                  <app-tab-task-attachment
                    *ngIf="!CaseSummary?.caseDetails?.isLoading"
                    [entityID]="CaseSummary?.ID"
                    [entityType]="'case'"
                    [SummaryAttachmentTable]="CaseSummary?.attachmentJagTable"
                    [ConfigAttachmentTable]="config.attachmentJagTable"
                    [AttachmentFolderStates]="openAttachmentFolder"
                    (attachmentFolderStatesChange)="saveAttachmentFolderStates($event)"
                    [tableDrawerIsLoading]="tableDrawerIsLoading"
                    [Events]="Events"
                    [auftragData]="CaseSummary?.caseDetails?.data"
                    [taskList]="CaseSummary?.taskList.data">
                  </app-tab-task-attachment>
                </div>
                <!--4 - GDV Quittung -->
                <div *ngIf="CaseSummary?.caseDetails?.data?.showGDVActions" class="content">
                  <app-case-gdv-receipt
                    *ngIf="!CaseSummary?.caseDetails?.isLoading"
                    [caseID]="caseTable.selectedRow[caseTable.selectKey]"
                    [SummaryGdvReceipt]="CaseSummary?.gdvReceiptList?.data"
                    [SummaryAttachmentTable]="CaseSummary?.attachmentJagTable"
                    [ConfigAttachmentTable]="config.attachmentJagTable"
                    [ConfigGdvReceipt]="config.gdvReceiptList"
                    [tableDrawerIsLoading]="tableDrawerIsLoading"
                    [Events]="Events">
                  </app-case-gdv-receipt>
                </div>
                <!--5 - Belege -->
                <div class="content">
                  <app-tab-task-receipt *ngIf="!CaseSummary?.caseDetails?.isLoading"
                                        [ConfigReceiptTable]="config.receiptList"
                                        [SummaryReceiptTable]="CaseSummary?.receiptList"
                                        [tableDrawerIsLoading]="tableDrawerIsLoading"
                                        [Events]="Events">
                  </app-tab-task-receipt>
                </div>
                <!--6 - Leistungsaufstellungen -->
                <div class="content">
                  <app-tab-task-leistung *ngIf="!CaseSummary?.caseDetails?.isLoading"
                                         [ConfigLeistungTable]="config.leistungList"
                                         [SummaryLeistungTable]="CaseSummary?.leistungList"
                                         [tableDrawerIsLoading]="tableDrawerIsLoading"
                                         [Events]="Events">
                  </app-tab-task-leistung>
                </div>
                <div class="content">
                  <app-tab-task-flowtable
                    *ngIf="!CaseSummary?.caseDetails?.isLoading"
                    [ConfigFlowTable]="config.flowTable"
                    [SummaryFlowTable]="CaseSummary?.flowTable"
                    [Events]="Events">
                  </app-tab-task-flowtable>
                </div>
                <div class="content">
                  <div class="layout-1-auto">
                    <div class="content app-subarea">
                      <exg-data-list [allowSingleSelection]="false"
                                     [hidden]="CaseSummary?.dialogueQuestions?.data?.length == 0"
                                     [rowSource]="CaseSummary?.dialogueQuestions?.data"
                                     selectKey="dfID">
                        <ng-template #rowTemplate let-row>
                          <div class="list-row list-single-line-auto-1 typo-small">
                            <div><strong>{{row.dfText}}</strong></div>
                            <div class="list-secondary-text"
                                 *ngIf="row.deValue && row.deValue.length > 0">{{row.deValue}}</div>
                            <div class="list-secondary-text" style="font-style: italic"
                                 *ngIf="!row.deValue || row.deValue.length === 0">&lt;&lt;Die Frage wurde noch nicht
                              beantwortet&gt;&gt;
                            </div>
                          </div>
                        </ng-template>
                      </exg-data-list>
                    </div>
                    <div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </app-exg-tab-v2>
          </div>
        </div>
      </div>
    </div>
    <!-- Drawerbar right -->
    <div class="app-drawer">
      <ng-container *ngIf="excSecurity.isFeatured('CASEREAD')">
        <i (click)="toggleRightDrawer();"
           [class.fal]="!rightDrawerVisible"
           [class.fas]="rightDrawerVisible"
           [class.disabled]="appSvc.isTableLoading(caseTable) || appSvc.isTableEmpty(caseTable)"
           [tooltip]="getResource('openDetails')" flow="left"
           class="fa-info app-drawer-icon ">
        </i>
        <i class="search-filter-seperator"></i>
        <i (click)="openWorkspaceV2()"
           class="fal fa-chevron-right search-filter-action"
           [tooltip]="getRessource('openWorkspace')" flow="left"
           [class.disabled]="caseTable.isLoading
                             || !caseTable.selectedRow
                             || (!excSecurity.isFeatured('CASEREAD') && !excSecurity.isFeatured('CASEEDIT') )">
        </i>
        <i class="search-filter-seperator"></i>
        <app-exg-dropdown position="underleft">
          <ng-template #hostTemplate>
            <i class="search-filter-action fal fa-plus"
               [tooltip]="'Hinzufügen'" flow="left"
               [class.disabled]="CaseSummary?.isLoading || caseTable.isLoading"></i>
          </ng-template>
          <ng-template #contentTemplate let-popup>
            <div class="content" style="max-height: 500px">
              <div (click)="config.newReport(); popup.close();" class="md-menu-item">Bericht</div>
              <div (click)="config.newServiceRecord(); popup.close();"
                   *ngIf="excSecurity.isFeatured('DEVELOPMENT')"
                   class="md-menu-item">
                Leistungsaufstellung
              </div>
              <div *ngIf="!(CaseSummary?.defaultMessages?.data.length > 0)"
                   (click)="config.newMessage(); popup.close();"
                   class="md-menu-item">Nachricht
              </div>
              <app-exg-dropdown *ngIf="CaseSummary?.defaultMessages?.data.length > 0" [adaptiveHeightActive]="true">
                <ng-template #hostTemplate>
                  <div class="md-menu-item">Nachricht...</div>
                </ng-template>
                <ng-template #contentTemplate let-popup>
                  <div (click)="config.newMessage();popup.close();" class="md-menu-item typo-left">Leere Nachricht</div>
                  <ng-container *ngFor="let row of CaseSummary?.defaultMessages?.data">
                    <div (click)="config.newDefaultMessage(row.dmsgID);popup.close();"
                         class="md-menu-item typo-left">{{row.dmsgBezeichnung}}</div>
                  </ng-container>
                </ng-template>
              </app-exg-dropdown>
              <div *ngIf="excSecurity.isFeatured('NTZEDIT')"
                   (click)="config.newNote();popup.close();" class="md-menu-item">
                Notiz
              </div>
              <div (click)="config.showAttachmentUploadModal(); popup.close();" class="md-menu-item">Anlage</div>
              <div *ngIf="excSecurity.isFeatured('TASKCREATE')" (click)="createNewTask(); popup.close();"
                   class="md-menu-item">Vorgang
              </div>
            </div>
          </ng-template>
        </app-exg-dropdown>
        <i class="search-filter-action fal fa-image" (click)="config.showAttachmentPreview()"
	         [class.disabled]="CaseSummary?.isLoading || caseTable.isLoading"
	         [tooltip]="'Anlagen ansehen'"
	         flow="left"></i>
	      <i (click)="config.showHistory()" class="search-filter-action {{getResource('Tabs.History.Icon')}}"
	         [class.disabled]="CaseSummary?.isLoading || caseTable.isLoading"
	         [tooltip]="'Historie'" flow="left"></i>
	      <ng-container
		      *ngIf="excSecurity.isFeatured('HISTORYEXTREAD')">
		      <i class="search-filter-action fa-light fa-list-timeline"
		         *ngIf="excSecurity.isFeatured('HISTORYEXTREAD')"
		         (click)="OpenDetailHistoryModal()"
		         [class.disabled]="CaseSummary.isLoading || caseTable.isLoading"
		         [tooltip]="'History'"
		         flow="left"></i>
	      </ng-container>
	      <i class="search-filter-seperator"></i>
	      <i class="search-filter-action fa-light fa-folders"
	         *ngIf="excSecurity.isFeatured('DOCUMENTMGMT')"
	         (click)="openFileOverview()"
           [class.disabled]="CaseSummary.isLoading || caseTable.isLoading"
	         [tooltip]="'Dokumenten Manager'"
	         flow="left"></i>
	      <i class="search-filter-action fa-light fa-screwdriver-wrench"
	         *ngIf="excSecurity.isFeatured('REPORTBUILDER')"
	         (click)="openReportBuilder()"
           [class.disabled]="CaseSummary.isLoading || caseTable.isLoading"
	         [tooltip]="'Neuen Report erstellen'"
	         flow="left">
        </i>
        <ng-container *ngIf="excSecurity.isFeatured('CASECLONE')">
          <i class="search-filter-seperator"></i>
          <i class="search-filter-action fa-light fa-clone"
             (click)="cloneSelectedCase()"
             [class.disabled]="caseTable.isLoading
                       || !caseTable.selectedRow
                       || CaseSummary?.isLoading"
             [tooltip]="'Auftrag klonen'"
             flow="left">
          </i>
        </ng-container>
      </ng-container>
    </div>
    <!-- Pager -->
    <exg-pager (PageChange)="caseTable.pageChanged($event)" *ngIf="!init"
               [pagingSource]="caseTable.paging"
               class="span-layout app-pager">
      <ng-template #leftTemplate>
        <app-exg-dropdown class="typo-small" [list]="preFilterDefinition" elementclass="typo-left" maxHeight="250px"
                          [label]="selectedMod.caption" position="abovecenter" listdisplay="caption"
                          (change)="changePreFilterMod($event.value)">
        </app-exg-dropdown>
        <app-exg-dropdown class="typo-small" [list]="selectedMod.types" elementclass="typo-left" maxHeight="250px"
                          [label]="selectedType.caption" position="abovecenter" listdisplay="caption"
                          (change)="changePreFilterType($event.value)">
        </app-exg-dropdown>
      </ng-template>
      <ng-template #rightTemplate>
        <div class="app-pager-chips">
          <app-exg-filter-chips #VCFilterChips
                                [inputDataTable]="caseTable"
                                [VCFilterControl]="{ VCFilter: VCcaseTableFilterControl, VCSearch: VCcaseTableSearchControl, VCSort: VCcaseTableSortControl}">
          </app-exg-filter-chips>
        </div>
      </ng-template>
    </exg-pager>
  </div>
</div>
